// extracted by mini-css-extract-plugin
module.exports = {"center":"ModalHub_center__1IJ9U","backdrop":"ModalHub_backdrop__2P7Qc"};